import settings from '@/constants/constants';
import { Alert, Box, Link, Typography } from '@montugroup/design-system';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import { styled } from '@mui/material';

const InfoAlert = styled(Alert)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& .MuiAlert-icon': { color: theme.palette.text.primary },
  '& .MuiAlert-message': { color: theme.palette.text.primary },
}));

export const DirectToDoctorConsultEligible = () => {
  return (
    <>
      <Typography variant="subtitle2" sx={{ mb: 4 }}>
        What you&apos;ll need:
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, mb: 6 }}>
        <Typography variant="subtitle2">💳 Medicare card details</Typography>
      </Box>
      <InfoAlert severity="info" icon={<AccessTimeOutlinedIcon fontSize="medium" />} sx={{ mb: 4 }}>
        <Typography variant="body1">
          Please allow up to <strong>10 minutes</strong> to complete this form
        </Typography>
      </InfoAlert>
      <InfoAlert severity="info" icon={<GppGoodOutlinedIcon fontSize="medium" />} sx={{ mb: 8 }}>
        <Typography variant="body1">
          Your details are kept secure and confidential. Read our{' '}
          <Link href={settings.videoConsult.privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </Link>
          .
        </Typography>
      </InfoAlert>
    </>
  );
};
